import { render, staticRenderFns } from "./gradeInfo.vue?vue&type=template&id=62423b5a&scoped=true"
import script from "./gradeInfo.vue?vue&type=script&lang=js"
export * from "./gradeInfo.vue?vue&type=script&lang=js"
import style0 from "./gradeInfo.vue?vue&type=style&index=0&id=62423b5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62423b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62423b5a')) {
      api.createRecord('62423b5a', component.options)
    } else {
      api.reload('62423b5a', component.options)
    }
    module.hot.accept("./gradeInfo.vue?vue&type=template&id=62423b5a&scoped=true", function () {
      api.rerender('62423b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basic/gradeInfo.vue"
export default component.exports